<template>
  <div>
    <v-select
      v-model="parentModel"
      :items="parentItems"
      :disabled="props.disabled"
      variant="outlined"
      density="compact"
      bgColor="#ffffff"
      hideDetails
      itemTitle="text"
      itemValue="value"
      class="segment-builder--subtypes _subtypes"
      placeholder="Select integration"
      style="min-width: 180px"
      :menuProps="{ maxHeight: 410, offsetY: true, minWidth: 240 }"
      @update:modelValue="updateFilter"
    />
    <template v-if="parentModel === 'adobe_audience_id'">
      <div class="segment-builder--item next-selection">
        <RfChevronIcon class="fill-beige-50 mx-1 my-auto h-6 w-6 rotate-180" />
        <v-select
          v-model="filterObj.negative_match"
          :disabled="disabled"
          :items="Object.values(MatchTypeItems)"
          variant="outlined"
          density="compact"
          bgColor="#ffffff"
          hideDetails
          itemTitle="text"
          itemValue="value"
          height="32px"
          class="min-w-28"
          placeholder="Match Type"
          @update:modelValue="updateFilter"
        />
      </div>
      <div class="segment-builder--item next-selection">
        <RfChevronIcon class="fill-beige-50 mx-1 my-auto h-6 w-6 rotate-180" />
        <RfMultiChipInput
          v-model="filterObj.values"
          class="min-w-48"
          :disabled="disabled"
          placeholder="Audience Ids"
          @update:modelValue="updateFilter"
        />
      </div>
    </template>
  </div>
</template>

<script setup>
import { MatchTypeItems } from "@/utils/constants/SegmentsConstants";
import { onMounted, ref } from "vue";
import RfMultiChipInput from "@/components/RfMultiChipInput.vue";
import RfChevronIcon from "../icons/RfChevronIcon.vue";

const props = defineProps(["filter", "disabled"]);
const emit = defineEmits(["update:model"]);

/*
  filter: {
    integrations: {
      adobe_audience_id: { values: ['abc', 'def'], negative_match: false }
    }
  }
*/
const parentItems = [{ text: "Adobe Audience ID", value: "adobe_audience_id" }];
const parentModel = ref();
const filterObj = ref({});

const updateFilter = () => {
  const filter = { integrations: { [parentModel.value]: { ...filterObj.value } } };
  emit("update:model", filter);
};
const prepareFilter = () => {
  parentModel.value = Object.keys(props.filter.integrations)[0];
  filterObj.value = props.filter.integrations[parentModel.value] || {};
};

onMounted(prepareFilter);
</script>
